export const MulticolorHeadline = ({ firstSentence, secondSentence, breakBetween }:
  { firstSentence: string, secondSentence: string, breakBetween?: boolean }) => {
  return (
    <h2 className={"text-4xl md:text-5xl font-sans-bold m-0 indent-0 text-left"}>
      <span className={`text-brandprimary pr-3 ${breakBetween ? "block" : ""}`}>{firstSentence}</span>
      <span className={"text-brandsecondary"}>{secondSentence}</span>
    </h2>

  );
}